// extracted by mini-css-extract-plugin
export default {"root":"wYX6cInk","tradesList":"un4nSAZ4","win":"NSCMWPCu","loss":"iV8ZzvXU","spinContainer":"VfpKxVlz"};